import { render, staticRenderFns } from "./AdministrativeRayons1946.vue?vue&type=template&id=1ac379c4&"
import script from "./AdministrativeRayons1946.vue?vue&type=script&lang=js&"
export * from "./AdministrativeRayons1946.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports